import { ProductInterface } from '@pylot-data/fwrdschema'
import { ProductStockStatus } from '@pylot-data/enums/ProductStockStatus.d'
/**
 * https://schema.org/ItemAvailability - has more statuses, but we handle only two
 *
 * @param stockStatus
 */
export const getProductAvailability = (
    product?: ProductInterface | null
): string => {
    if (product && product.stock_status === ProductStockStatus.InStock)
        return 'https://schema.org/InStock'
    return 'https://schema.org/OutOfStock'
}
